import { useRef } from "react";
import { Box, Tooltip, Switch } from "@mui/material";
import logsm from '../../layouts/wsm.png'
import logsmy from '../../layouts/logosm.png'
import ReactCountryFlag from "react-country-flag";

const resposive = { display: { xs: 'none', md: 'block' } }
export default function TopBar({ video_mode, selectedCamera,
    cameras, setSelectedCamera, navigate, sepIcon, homeIcon, checkState, checkStatus }) {
    const boxStyle = { mb: 0.5, fontWeight: 600, display: { xs: 'none', md: 'block' } }
    return (
        <Box className="top-bar" sx={{
            height: "60px", display: 'flex', alignItems: 'center',
            p: 1, px: 4, gap: 2,
        }}>

            {localStorage?.selectedTheme == "dark" && <Box><img src={logsm} width={18} /></Box>}
            {localStorage?.selectedTheme != "dark" && <Box><img src={logsmy} width={18} /></Box>}
            <Box sx={boxStyle} onClick={() => navigate("/cameras/", { state: { tab: video_mode ? "Live cam" : "Timelapse cam" } })}>
                {homeIcon}
            </Box>
            <Box sx={{ fontSize: 14, gap: 1, width: 1, display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>

                <Box sx={boxStyle}>Project</Box>
                <Box sx={resposive}>{sepIcon}</Box>
                <Box sx={boxStyle}>{selectedCamera.company_name}</Box>
                <Box sx={resposive}>{sepIcon}</Box>
                <Box sx={boxStyle}>{selectedCamera.project_name}</Box>
                <Box sx={resposive}>{sepIcon}</Box>
                <Box className="over-menu" sx={{ zIndex: 9999 }}>
                    <Box sx={{ ...boxStyle, display: 'flex' }}>{selectedCamera?.camera_name}</Box>
                    <Box className="hover-box">
                        <Box className="hover-content" sx={{ px: 3 }}>
                            {(cameras || []).map(camera => <Box sx={{ minWidth: 200 }} className={"menu-i" + (camera.id == selectedCamera.id ? " selected" : "")} onClick={() => setSelectedCamera(camera)}>{camera.camera_name}</Box>)}
                        </Box>
                    </Box>
                </Box>
            </Box>
            {checkState && <Box display={'flex'} alignItems={'center'} className="title" sx={{ fontSize: 12 }}>

                Tool <input type="checkbox" value={checkStatus} defaultChecked={true} onChange={(e) => { checkState(e.target.checked) }} />
            </Box>}
            <Box >
                <Tooltip title={selectedCamera?.country_name} arrow>
                    <ReactCountryFlag countryCode={selectedCamera?.country} svg style={{ width: 20 }} />
                </Tooltip>
            </Box>
            <Box sx={{ display: { xs: 'none', sm: 'flex' } }} gap={1}>
                <img src={selectedCamera?.project_image} style={{ borderRadius: 6, objectFit: "cover" }} height="36" />
                <img src={selectedCamera?.company_image} style={{ borderRadius: 6, objectFit: "cover" }} height="36" />
            </Box>
        </Box>
    )
}